<template>

  <component :is="el" :label="label" :required="required">

    <el-cascader
      v-model="formData"
      :placeholder="placeholder"
      :options="categories"
      :disabled="disabled"
      :show-all-levels="showLevels"
      filterable
      :props="{label: 'label', value: 'value'}"
      :size="size"
      @change="updated">
  </el-cascader>

</component>

</template>

<script>

import {assetCategoryData} from '@/components/Data'

export default {
  name: 'select-equip-category',

  props: {
    label: {
      type: String,
      default: 'Category'
    },
    value: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'normal'
    },
    placeholder: {
      type: String,
      default: 'Equipment Category...'
    },
    helpText: {
      type: String,
      default: null
    },
    showLevels: {
      type: Boolean,
      default: true
    },
    selectAll: {
      type: Boolean,
      default: true
    },
    returnLevels: {
      type: Boolean,
      default: false
    },
    create: {
      type: Boolean,
      default: true
    },
    noForm: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    updated (selected) {

      if (this.isArray(this.formData)) {

        this.formData = selected
        this.$emit('input', selected)
        this.$emit('change', selected)

      } else {

        if (this.returnLevels) {
          var value = ''

          for (var i = 0; i <= 4; i++) {

            if (selected[i]) {
              value += (i > 0 ? ' / ' : '') + selected[i]
            }
          }

          this.formData = value
          this.$emit('input', value)
          this.$emit('change', value)

        } else {
          // Select the furthest child back then parent.
          for (i = 3; i > -1; i--) {

            if (selected[i]) {
              this.formData = selected[i]
              this.$emit('input', selected[i])
              this.$emit('change', selected[i])
              break
            }
          }
        }

      }
    }
  },

  data () {
    return {
      el: this.noForm ? 'div' : 'el-form-item',
      formData: this.removeNullArray(this.value),
      categories: assetCategoryData
    }
  }
}
</script>



// WEBPACK FOOTER //
// SelectEquipCategory.vue?12b4a45f